define(['underscore'], (_) => {
    return (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelContext, ErrorHandlingService)=> {
        const translateFn = TranslateService.instant;

        function wrappedLoadSave(action, model) {
            const promise = action.call(undefined, null, model);
            return promise.then(submissionDTO => ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext));
        }

        function deleteCorruptNodeonCancel(model){
            //validate all the drivers that are in viewmodel
            var corruptedDrivers = [];
            var drivers = model.draftData.lobs.personalAuto.drivers;

            if (typeof drivers != 'undefined' && drivers.length > 0){

                _.forEach(drivers, function(item, index){
                    if (!drivers.getElement(index).aspects.subtreeValid){
                        corruptedDrivers.push(drivers.getElement(index).value);
                    }
                });
            }

            _.forEach(corruptedDrivers, function(driver){
                model.draftData.lobs.personalAuto.value.removeDriver(driver);
            });

            //remove the vehicles also if all the drivers are removed
            //validating vehicle node
            if (typeof model.draftData.lobs.personalAuto.drivers != "undefined" && model.draftData.lobs.personalAuto.drivers.length === 0){
                model.draftData.lobs.personalAuto.vehicles.value = [];
            }

            var corruptedVehicles = [];

            var vehicles = model.draftData.lobs.personalAuto.vehicles;
            if (typeof vehicles != 'undefined' && vehicles.length > 0){
                _.forEach(vehicles, function(item, index){
                    if (!vehicles.getElement(index).aspects.subtreeValid){
                        corruptedVehicles.push(vehicles.getElement(index).value);
                    }
                });
            }

            _.forEach(corruptedVehicles, function(vehicle){
                model.draftData.lobs.personalAuto.value.removeVehicle(vehicle);
            });
        }

        const ACTION_MSG = {
            cancelPrompt: {
                noSaveRequired: 'quoteandbind.common.config.FlowConfig.The information you have entered will not be saved',
                saveDraft: 'quoteandbind.common.config.FlowConfig.The information previously entered will be stored as a draft quote submission',
                saveOffering: 'quoteandbind.common.config.FlowConfig.The information previously entered will be stored as a quote submission'
            },
            checkAvailability: {
                /*error: {
                    title: 'quoteandbind.common.config.FlowConfig.Unable to request a quote',
                    message: 'quoteandbind.common.config.FlowConfig.Sorry we are unable to quote for this location and start date.'
                },
                progress: {
                    title: 'quoteandbind.common.config.FlowConfig.Checking product availability',
                    message: 'quoteandbind.common.config.FlowConfig.Checking if a quote can be provided for that location'
                }*/
                error: {
                    title: 'quoteandbind.controllers.ZipCodeCtrl.Error',
                    //message: 'quoteandbind.controllers.ZipCodeCtrl.We do not recognize the zipcode entered, please try again.'
                    message:'It seems you have entered a zip code not within the region of AAA Carolinas. Please try again or click '
                    +'<a target="_blank" href="http://www.aaa.com/stop">here</a>'+' and reenter your zip code to find the AAA Club in your state.'
                },
                progress: {
                    title: 'quoteandbind.common.config.FlowConfig.Checking product availability',
                    message: 'quoteandbind.controllers.ZipCodeCtrl.Checking for availability in your state...'
                },
                systemdown: {
                    title: 'quoteandbind.controllers.ZipCodeCtrl.Error',
                    message: 'quoteandbind.controllers.ZipCodeCtrl.PC system down error'
                }
                
            },
            checkPeriodStartDateChanged: {
                error: {
                    title: 'quoteandbind.common.config.FlowConfig.Unable to request a quote',
                    message: 'quoteandbind.common.config.FlowConfig.Sorry coverage is not available for the effective date specified.'
                },
                progress: {
                    title: 'quoteandbind.common.config.FlowConfig.Checking product availability',
                    message: 'quoteandbind.common.config.FlowConfig.Checking if coverage is available for that date.'
                }
            },
            createSubmission: {
                error: {
                    title: 'quoteandbind.common.config.FlowConfig.Unable to create submission',
                    message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to create the quote submission.'
                },
                progress: {
                    message: 'quoteandbind.common.config.FlowConfig.Creating a new quote submission...'
                }
            },
            saveSubmission: {
                error: {
                    title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
                    message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
                },
                progress: {
                    message: 'quoteandbind.common.config.FlowConfig.Saving quote submission details...'
                }
            },
            saveAndQuoteSubmission: {
                
                error: {
                    title: 'quoteandbind.common.config.FlowConfig.Unable to generate a quote',
                    message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to calculate a quote.'
                },
                progress: {
                    message: 'quoteandbind.common.config.FlowConfig.Calculating Quote...'
                }
            },
            bindSubmission: {
                error: {
                    title: 'quoteandbind.common.config.FlowConfig.Unable to purchase quote',
                    message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to bind your quote submission'
                },
                progress: {
                    message: 'quoteandbind.common.config.FlowConfig.Processing Payment...'
                }
            }
        };
        const ACTIONS = {
            checkAvailability: (model, availabilityRequest) => {
                //wrap the availablity check promise in a promise that returns the model with the policy address set
                return new $q((resolve, reject) => {
                    const availabilityPromise = AvailabilityService.checkAvailabilityBasedOnPostalCode(null, availabilityRequest);
                    availabilityPromise.then(
                        availabilityResp => {
                            if (!availabilityResp.isAvailable) {
                                reject();
                            }
                            // Set the policy address using the availability response if no address has been set yet
                            if (!angular.isDefined(model.draftData.policyAddress.value)) {
                                model.draftData.policyAddress.value = availabilityResp.addressCompletion;
                            }
                            resolve(model);
                        },
                        error => {
                           reject(error);
                        }
                    );
                });
            },
            cancel: (model) => {
                if (!model.quoteID.value) {
                    //no submission was created so just exit without saving
                    return $q.resolve(model);
                }
                if (!model.quoteData.value) {
                    if(model.draftData.productCode.value === 'PersonalAuto') 
                     { deleteCorruptNodeonCancel(model); }
                    return LoadSaveService.saveSubmission(null, model.value);
                }
                return LoadSaveService.saveQuotedSubmission(null, model.value);
            },
            createSubmission: ({ value: submission }) => wrappedLoadSave(LoadSaveService.createSubmission, submission),
            saveDraftSubmission: ({ value: submission }) => wrappedLoadSave(LoadSaveService.saveSubmission, submission),
            saveQuotedSubmission: ({ value: submission }) => wrappedLoadSave(LoadSaveService.saveQuotedSubmission, submission),
            saveAndQuoteSubmission: ({ value: submission }) => wrappedLoadSave(LoadSaveService.saveAndQuoteSubmission, submission),
            bindSubmission: ({ value: submission }) => wrappedLoadSave(LoadSaveService.bindSubmission, submission)
        };


        return {
            globalExits(step, junction) {
                junction('error');

                junction('returnHome');

                junction('cancel')
                    .data({
                        confirmationMsg(model) {
                            if (!model.quoteID.value) {
                                return ACTION_MSG.cancelPrompt.noSaveRequired;
                            }
                            if (!model.quoteData.value) {
                                return ACTION_MSG.cancelPrompt.saveDraft;
                            }
                            return ACTION_MSG.cancelPrompt.saveOffering;
                        }
                    })
                    .onNext.doAction(ACTIONS.cancel, ACTION_MSG.saveSubmission).thenGoTo('returnHome', 'error');

            },
            availabilityCheck(step, junction) {
                junction('checkAvailability', true)
                    .onNext.doAction(ACTIONS.checkAvailability, ACTION_MSG.checkAvailability).thenGoTo('productAvailable', 'error');

                junction('productAvailable');

            },
            needToSaveCheck(step, junction) {
                junction('checkNewSubmissionOrIfPeriodStartDateHasChanged', true)
                    .onNext.branch(
                        (model, args) => {
                            if (!model.quoteID.value) {
                                return 'newSubmission';
                            }
                            if (args.periodStartDateChanged) {
                                return 'periodStartDateChanged';
                            }
                            return 'needToSaveCheckSuccess';
                        }
                    );

                junction('newSubmission')
                    .onNext.doAction(ACTIONS.createSubmission, ACTION_MSG.createSubmission).thenGoTo('needToSaveCheckSuccess', 'error');


                junction('periodStartDateChanged')
                    .onNext.doAction(ACTIONS.checkAvailability, ACTION_MSG.checkPeriodStartDateChanged).thenGoTo('needToSaveCheckSuccess', 'error');

                junction('needToSaveCheckSuccess');
            },
            quote(step, junction) {
                junction('generateQuote', true)
                    .onNext.doAction(ACTIONS.saveAndQuoteSubmission, ACTION_MSG.saveAndQuoteSubmission).thenGoTo('quoteDetails', 'quoteFail'); //US-10685, mofified to allow user to edit.

                step('quoteDetails')
                    .onNext.doAction(ACTIONS.saveQuotedSubmission, ACTION_MSG.saveSubmission).thenBranch(
                    ({value: submission}) => {
                        if(submission.draftData.productCode == 'Homeowners'){
                            return 'nextSteps';
                        }else{
                            return 'offeringSelected';
                    }
                },
                () => 'quoteDetails')//US-10685, mofified to allow user to edit.
                /*).thenGoTo('offeringSelected', 'error')*/
                    .skipOnResumeIf(() => false)
                    .label(() => translateFn('quoteandbind.wizard.step.Quote'));

                junction('offeringSelected');
                junction('nextSteps');

                junction('quoteFail').onNext.branch(
                    (model, args) => {
                    //ENHC0012054- Property / Update Eligibility for Protection Class 10 and 10W - added homeownder condition for display error msg - Arpita
                        if(model.draftData.productCode.value == 'Homeowners') {
                            return ErrorHandlingService.getQuoteExceptionHandler(args,model);
                        }
                        else if(model.draftData.productCode.value == 'PersonalAuto') {
                            return ErrorHandlingService.getQuoteExceptionHandler(args,model);
                        }
                        else{
                            return 'error';
                        }
                    }
                );
            },
            bindAndPay(step, junction) {
                step('paymentDetails', true)
                    .onNext.goTo('paymentConfirmation')
                    .skipOnResumeIf(model => model.selectedPaymentPlan.value)
                    .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                    .label(() => translateFn('quoteandbind.wizard.step.Payment Details'));

                step('paymentConfirmation')
                    .onNext.doAction(ACTIONS.bindSubmission, ACTION_MSG.bindSubmission).thenGoTo('confirmation', 'bindFail')
                    .skipOnResumeIf(model => model.selectedPaymentPlan.value)
                    .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                    .label(() => translateFn('quoteandbind.wizard.step.Payment Confirmation'));

                junction('bindFail').onNext.branch(
                    (model, args) => {
                    return ErrorHandlingService.getBindExceptionHandler(args,model);
                    }
                 );

                junction('confirmation');

            }

        };
    };
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/config/FlowConfig.js
 **/